export const select = {
  css: ({ dt }: any) => `
        .p-select {
          box-shadow: none;
          border-radius: 1rem;
          border: 1px solid rgb(226 232 240 / var(--tw-border-opacity, 1));
          height: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 0.5rem;
        }
        
        .p-select-overlay {
          border-radius: 1rem;
          border: 1px solid rgb(226 232 240 / var(--tw-border-opacity, 1));
          padding: 0.5rem;
          padding-top: 0.25rem;
          padding-bottom: 0.25rem;
        }

        .p-disabled {
          background: white !important;
        }
        `,
};
